<template>
  <div class="row align-center justify-center formLogin">
    <div class="container justify-content-between align-items-center">
      <img src="https://ibliss-icons-prod.s3.us-east-1.amazonaws.com/marca_empresarial/image-welcomeDefault.png" />
      <h1 color="primary">{{ $t('login.label.title') }}</h1>
      <v-form ref="form" v-model="valid" lazy-validation class="col-md-6 col-sm-8">
        <v-text-field id="correo" :label="$t('label.email.title')" :placeholder="$t('label.email.text')" append-icon="mdi mdi-account-outline"
          outlined color=primary v-model="user.correo" :rules="correoRules" :counter="200" :maxlength="201"
          required></v-text-field>

        <v-text-field id="contrasena" :label="$t('login.label.password.title')" :placeholder="$t('login.label.password.text')"
          :append-icon="marker ? 'mdi-eye' : 'mdi-eye-off'" outlined v-model="user.contrasenia" :type="type"
          :rules="contraseniaRules" color=primary :counter="15" :maxlength="16" name="contrasenia" required
          autocomplete="on" v-on:keyup.enter="validate" @click:append="showpassword"></v-text-field>
        <br />
        <v-btn large block rounded :loading="loading" color="primary" @click="validate(); loader = 'loading'"
          style="color: white; border-radius: 50px;">
          {{ $t('button.signIn') }}
        </v-btn>
        <passwordValidation v-if="dialog" :forgottenPass="forgottenPass">
        </passwordValidation>
        <termsConditions v-if="dialogTyC" :termsConditions="termsConditions">
        </termsConditions>
      </v-form>
      <validationEmailLogin />
      <validationCodeLogin v-if="dialogEmail" :validateProps="timeLogin">
      </validationCodeLogin>
      <LanguageSwitcher />
    </div>
  </div>
</template>

<script>

import {
  LOGIN_M,
  ACTION_LOGIN,
} from "@/views/login/store/types/types.js";
import actions_token from "@/plugins/http/actions_token/actions_token.js";
import termsConditions from "@/views/login/pages/terms_conditions/terms_conditions_page.vue";
import passwordValidation from "@/views/login/pages/password_validation/password_validation_page.vue"
import validationEmailLogin from '@/views/recover_forgotten_password/page/validation_email/validation_email_page.vue';
import validationCodeLogin from '@/views/recover_forgotten_password/page/validation_code/validation_code_page.vue';

import { mapActions } from 'vuex';
import Swal from "sweetalert2";
import EventBus from '@/utils/event_bus.js';
import LanguageSwitcher from '@/shared/components/LanguageSwitcher.vue';
import i18n from '@/plugins/i18n';

export default {
  name: "formComponent",
  components: {
    termsConditions,
    passwordValidation,
    validationEmailLogin,
    validationCodeLogin,
    LanguageSwitcher,
  },
  mounted() {
    EventBus.$on('modal', (forgottenPass) => {
      this.forgottenPass = forgottenPass;
      this.dialog = true;
    });

    EventBus.$on('TyC', (TyC) => {
      this.termsConditions = TyC;
      this.dialogTyC = true;
    });

    EventBus.$on('modal-validateEmail', (time) => {
      this.timeLogin = time;
      this.dialogEmail = true;
    });

    EventBus.$on('clear', () => {
      this.user = {
        correo: null,
        contrasenia: null
      };
    });
  },

  data() {
    return {
      timeLogin: 0,
      dialog: false,
      dialogTyC: false,
      dialogEmail: false,
      termsConditions: false,
      forgottenPass: false,
      valid: true,
      loading: false,
      loader: null,
      correoRules: [
        v => !!v || this.$t('label.email.required'),
        v => /.+@.+\..+/.test(v) || this.$t('label.email.invalid'),
        v => !v || v.length <= 200 || this.$t('label.email.maxLength'),
      ],
      marker: true,
      type: "password",
      contraseniaRules: [
        v => !!v || this.$t('label.password.required'),
        v => !v || v.length >= 8 || this.$t('label.password.minLength'),
        v => !v || v.length <= 15 || this.$t('label.password.maxLength'),
      ],
      user: {
        correo: null,
        contrasenia: null,
      },

    }
  },

  watch: {
    loader() {
      const l = this.loader
      this[l] = !this[l]
      setTimeout(() => (this[l] = false), 3000)
      this.loader = null
    },
  },

  methods: {
    ...mapActions({
      iniciarSesion: `${LOGIN_M}${ACTION_LOGIN}`
    }),
   
    async validate() {
      if (!this.$refs.form.validate()) {
        return Swal.fire({
          icon: 'error',
          title: i18n.t('label.invalid.title'),
          text: i18n.t('label.invalid.text'),
          confirmButtonColor: '#6E17A5'
        })
      } else {
        this.user.correo = this.user.correo.toLowerCase();
        await actions_token._createdToken(this.user);
        const token = JSON.parse(sessionStorage.getItem('token'));
        sessionStorage.setItem('email', btoa(this.user.correo));
        if (token) {
          this.iniciarSesion(this.user).catch(() => {
            sessionStorage.clear();
          });
        }
      }
    },

    showpassword() {
      this.type = this.type === "password" ? "text" : "password";
      this.marker = !this.marker;
    },

  },
};
</script>

<style lang="css" scoped>
body {
  font-family: 'Nunito Sans', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Amsi Pro', sans-serif;
}

.formLogin{
  height: 100vh;
}

img {
  width: 30vh;
}

.container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 3vh;
  color: #6E17A5;
}

@media screen and (max-width: 500px) {
  .row {
    padding-top: 10vh;
    margin: auto;
  }
}
</style>